<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import exportModal from './exportModalContent.vue'

export default {
  name: 'exportButtonAndModal',
  components: {
    exportModal
  },
  props: ['zone','parametre','nameproject','name','appurl','routesubmit','mode','pvfields'],
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    afficheModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<template>
  <div>
    <button id="show-modal" class="buttonOriginal" @click="afficheModal" :title="trans.get('common.export_ppt_action')"><i class='fa fa-file-powerpoint-o'></i></button>
  
      <!-- use the modal component, pass in the prop -->
    <exportModal v-if="showModal" @close="closeModal" :routesubmit="this.routesubmit" ></exportModal>
  </div>
</template>